<template>
  <div class="aena"
        v-dragscroll.y
        style="overflow-y:scroll;"
  >
    <table
      cellspacing="0"
      cellpadding="0"
      style="height: calc(100vh);"
    >
      <tr class="title"
        :style="{ 'margin-top': isBanner ? '200px' : null}"
      >
        <td>
          <v-layout wrap style="width:1080px;padding: 20px 20px;" class="title">
            <v-flex xs6 style="text-align: left;font-weight:700;font-family: MontserratBold, sans-serif !important;">
              <v-layout wrap>
                <v-flex xs6
                  style="text-align: left;font-weight:700;font-family: MontserratBold, sans-serif !important;"
                  :style="{ opacity: type === 'sur' ? '100%' : '50%' }"
                  @click="handleGetData('granCanaria')"
                  :class="type === 'sur' ? 'active' : 'no-active'"
                >
                  Praia
                </v-flex>
                <v-flex xs6>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 style="text-align:right;padding-right:20px;font-weight:700;font-family: MontserratBold, sans-serif !important;">

              <small style="font-size: 0.7rem;text-transform: lowercase;margin-right: 20px;">{{ getTranslation({ es: 'actualizado a las ', en: 'updated: ' }, locale) }}{{prepareLMD(LMD, locale)}}</small>
              <v-icon color="#525c65" style="margin: -5px 10px 0 0;">mdi-airplane-takeoff</v-icon> {{getTranslation({ es: 'salidas', en: 'departures' }, locale)}}
            </v-flex>
          </v-layout>
        </td>
        <!--td colspan="4" style="width:50%;">
          <v-icon color="#525c65">mdi-airplane-takeoff</v-icon> Salidas
        </td-->
      </tr>
      <tr 
        class="sticky"
        :style="{ 'margin-top': isBanner ? '275px' : null}"
      >
        <!--th class="date">
          Fecha
        </th-->
        <th class="time">
          {{getTranslation({ es: 'hora', en: 'time' }, locale)}}
        </th>
        <th class="flightNumber">
          {{getTranslation({ es: 'vuelo', en: 'flight' }, locale)}}
        </th>
        <th class="company">
          {{getTranslation({ es: 'Compañía', en: 'company' }, locale)}}
        </th>
        <th class="destination">
          {{getTranslation({ es: 'destino', en: 'destination' }, locale)}}
        </th>
        <th style="width:auto">
        </th>
      </tr>
      <!--tr style="height:120px"
        :style="{ 'height': isBanner ? '300px' : '120px'}"
      >
      </tr-->
      <tr 
        v-for="(departure, index) of departures"
        :key="index"
        style="height: 120px;"
      >
        <!--td class="date">
          {{departure.fechaEstimada}} 
        </td-->
        <td class="time">
          {{ departure.time }}
        </td>
        <td class="flightNumber">
          {{departure.id}}
        </td>
        <td class="company">
          <img 
            :src="departure.image"
            width="150px"
            height="auto"
          />
        </td>
        <td class="destination">
          {{ departure.city }}
        </td>
        <td>
        </td>
      </tr>
      <tr v-if="loading">
        <td colspan="5" style="width:100%;">
          <v-progress-linear
            indeterminate
            color="gray"
          />
        </td>
      </tr>
      <tr>
        <td colspan="5" style="width:100%;">
        </td>
      </tr>
      <tr>
        <td colspan="5" style="width:100%;">
        </td>
      </tr>
      <tr>
        <td colspan="5" style="width:100%;">
        </td>
      </tr>
      <tr>
        <td colspan="5" style="width:100%;">
        </td>
      </tr>
      <tr>
        <td colspan="5" style="width:100%;">
        </td>
      </tr>
      <tr>
        <td colspan="5" style="width:100%;">
        </td>
      </tr>
      <tr>
        <td colspan="5" style="width:100%;">
        </td>
      </tr>
    </table>
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="gray"
        dark
      >
        <v-card-text>
          {{$t('common.pleaseStandBy', locale)}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//import bannerES from '@/assets/banner_transfer_es.jpg'
//import bannerEN from '@/assets/banner_transfer_en.jpg'
import bannerES from '@/assets/transferes02.jpg'
import bannerEN from '@/assets/transferen02.jpg'
import { dragscroll } from 'vue-dragscroll'
import axios from 'axios'
import utils from '@/services/utils'
export default {
  name: 'HomeView',
  directives: {
    dragscroll
  },
  props: {
    enterprise: {
      type: Object,
      default: null,
    },
    locale: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    loading: false,
    type: 'sur',
    LMD: null,
    departures: null,
    states: {
      INI: { 'es': ' ', 'en': ' ' },
      SCH: { 'es': ' ', 'en': ' ' },
      ULL: { 'es': 'Ult.Llamada', 'en': 'Last Call' },
      RET: { 'es': 'Restrasado', 'en': 'Delayed' },
      EMB: { 'es': 'Embarcado', 'en': 'Boarding' },
    },
    banner: bannerES,
  }),
  computed: {
    row () {
      const params = new URLSearchParams(window.location.search)
      const aux = params.get('row')
      return aux ? aux | 0 : 30
    },
    isBanner () {
      return false
    },
  },
  watch: {
    locale () {
    },
  },
  mounted () {
    this.getDepartures()
  },
  methods: {
    handleGetData (v) {
      this.getDepartures()
    },
    prepareLMD (v, locale) {
      if (!v) return null
      return v.toLocaleTimeString(locale)
    },
    getTranslation (v, locale) {
      return utils.getTranslation(v, locale)
    },
    getDepartures () {
      this.loading = true
      axios.get(`https://widgets.dviewcontent.com/barcelo/praia-airport.php`)
        .then(response => {
          this.LMD = new Date()
          this.departures = response.data
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    prepareGate(v) {
      if (v.puertaPrimera !== 'null') return v.puertaPrimera
      if (v.puertaSegunda !== 'null') return v.puertaSegunda
      return ''
    },
    prepareTime (v) {
      const aux = v.split(':')
      return `${aux[0]}:${aux[1]}`
    },
    prepareState (v, locale) {
      return this.states[v] ? this.getTranslation(this.states[v], locale) : v
    }
  }
}
</script>

<style scoped>
th {
  color: white;
  padding: 10px 0;
}
* {
  font-weight: 500;
}
table {
  width: 100%;
  text-transform: uppercase;
}
img {
  height: 100px;
  width: auto;
}
td {
  text-align: center;
  padding: 0 10px;
}
.sticky {
  margin-top:70px;
  position:fixed;
  width:100%;
  font-size: 0.6rem;
  background-color: #525c65;
}
.aena {
  height: 100%;
  overflow-y: scroll;
  font-family: MontserratRegular, sans-serif !important;
}
.aena .active {
  color: #525c65;
}
.aena .no-active {
  color: #525c6580;
}
.aena .title {
  position:fixed;
  width:100%;
  color: #525c65;
  background-color: white;
  font-weight:700 !important;
  font-family: MontserratBold, sans-serif !important;
}
.aena .date {
  width: 25px;
}
.aena .time {
  width: 160px;
}
.aena .flightNumber {
  width: 133px;
}
.aena .company {
  width: 234px;
}
.aena .destination {
  width: 575px;
}
</style>


